import { Box, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import BusinessOnboardingHeader from './components/BusinessOnboardingHeader';

type Props = {
  readonly children: ReactNode;
};

export default function BusinessOnboardingLayout({ children }: Props) {
  const theme = useTheme();
  const location = useLocation();
  const showOnboardingHeader = location.pathname.includes('/stage-2');

  return (
    <Box sx={{ height: { xs: '100dvh', md: '100vh' }, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      {showOnboardingHeader && <BusinessOnboardingHeader />}

      <Box
        bgcolor={theme.palette.background.default}
        sx={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          overflow: 'hidden'
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%'
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
}
